// Description: Loading step of the campaign creation step
// Updated:
// Author: Simon Franklin

// React
import React from 'react'

// Material UI Components
import { CircularProgress } from '@mui/material'

// Components and Functions for the project
import themeColors from '../../../components/ThemeColors/ThemeColors'

const LoadingStep = () => {
    return (
        <div style={{ width: "100%", height: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress style={{ color: themeColors.purple500 }} />
        </div>
    )
}

export default LoadingStep
